import type { ReactNode } from 'react';

/**
 * Tabellen-Kartenkontrakt (D-M0-K1 D2): jede Tabelle liegt in einer Karte
 * (Radius 16, shadow-sm, Hairline) mit optionalem Zähler-/Summenfuß; die
 * Filterleiste steht außerhalb über der Karte. Seit D-W1 (AD-2/AN-3/MW-1)
 * trägt die Karte optional ihren Titel selbst (Kartentitel-Muster) statt
 * eines frei schwebenden Abschnittstitels darüber.
 */
export function TableCard({
  children,
  title,
  footer,
  testId,
}: {
  children: ReactNode;
  title?: ReactNode;
  footer?: ReactNode;
  testId?: string;
}) {
  return (
    <div className="wb-table-card" data-testid={testId}>
      {title && <div className="wb-table-card-title">{title}</div>}
      <div className="wb-table-card-scroll">{children}</div>
      {footer && <div className="wb-table-card-footer">{footer}</div>}
    </div>
  );
}
